import { useIntl } from 'react-intl'
import InfoTip from '../../../components/novarium/InfoTip'
import { formatCount } from '../urgencySummaryFormat'

interface UrgencyInProgressNoteProps {
  /** Pacientes que todavía esperan o están en atención; con cero no se muestra nada. */
  count: number
}

/**
 * «En curso: N pacientes esperando o en atención»: lo que no entra en atendidos ni en retirados. Cómo cuentan (llegadas sí,
 * atendidos y retirados todavía no) se lee en el ⓘ. Lo comparten los indicadores del período y los del día.
 */
export default function UrgencyInProgressNote({ count }: UrgencyInProgressNoteProps) {
  const intl = useIntl()
  if (count <= 0) return null
  return (
    <p className="nv-note" role="status">
      <i className="pi pi-info-circle" aria-hidden="true" />
      <span>{intl.formatMessage({ id: 'UrgencySummaryInProgress' }, { count, countText: formatCount(intl, count) })}</span>
      <InfoTip text={intl.formatMessage({ id: 'UrgencySummaryInProgressHint' })} />
    </p>
  )
}
